<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "Redirect",
  // data() {
  //   return {
  //     loading: true,
  //     path: ""
  //   }
  // },
  mounted() {
    console.log('redirect mounted()')
    
    if (this.$route.query.hasOwnProperty('path')) {
      this.$router.push({ path: this.$route.query.path })
    } else {
      this.$router.push({ name: 'Home' })
    }
  },
}
</script>
